export enum BusinessMap {
  PUBLIC_RESETPASSWORD_SETPASSWORD,
  PUBLIC_RESETPASSWORD_RECOVERYPASSWORD,
}
